import React from 'react';
import { Navbar, Container } from 'react-bootstrap';
import { LoginHelper } from '../helpers';

export function NavigationBar() {
    return (
        <Navbar bg="light" variant="light" className="navigation-bar">
            <Container>
                <Navbar.Brand>
                    <img
                        alt=""
                        src="favicon.ico"
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                    />{' '}
                    IC "Порятунок"
                </Navbar.Brand>
                <Navbar.Text>
                    <button
                        className="logout-pile mx-5 py-1 px-3"
                        onClick={() => LoginHelper.logout()}
                    >
                        Вийти із системи
                    </button>
                </Navbar.Text>
            </Container>
        </Navbar>
    );
}
